import gql from 'graphql-tag'

export default gql`
  query getAllOccasions {
    getAllOccasions {
      id
      name
      img_url
      url_key
      type
    }
  }
`
